import React from 'react';
import PropTypes from 'prop-types';
import { GECKO_CONSTS, GECKO_UTILS, GeckoFields } from 'ui';
import BlockField from 'components/BlockField';
import MessageEditor from '../Skills/MessageEditor/PostScriptMessageEditor';
import SkillSuggestAnswerItem from './SkillSuggestAnswerItem';
import { BotTagManagerField } from '../BotTagManager';

import './index.scss';
const defaultValue = {
  name: null,
  internal_skill: 'SUGGEST_ANSWER',
  config: {
    messages: [''],
    answers: [''],
  },
};
const SkillSuggestAnswer = (props) => {
  const { value = defaultValue, botId = null, onChange = () => {} } = props;

  const fields = () => {
    return [
      {
        key: '',
        label: 'Configure the Suggest Answer Skill',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        width: '100%',
        className: 'BotTabEditContainer-section-heading',
        component: <div style={{ display: 'none' }}></div>,
      },
      {
        key: 'name',
        label: 'Skill Title',
        required: true,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      },
      {
        key: 'bot_tag_ids',
        label: 'Skill Tags',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        width: '100%',
        component: <BotTagManagerField item={value} />,
      },
      {
        key: 'config.messages',
        label: 'Message',
        required: true,
        width: '100%',
        className: 'MessageEditor',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: <MessageEditor />,
      },
      {
        key: 'config.answers',
        label: 'Options',
        required: true,
        width: '100%',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        component: (
          <BlockField
            removeButton={{
              icon: 'far fa-trash-alt',
              type: 'naked-danger',
            }}
            addButton={{
              type: 'default',
              name: `Add an Option`,
              icon: 'far fa-plus',
            }}
            field={{
              label: null,
              type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
              component: <SkillSuggestAnswerItem botId={botId} />,
            }}
            isReorderable
          />
        ),
      },
    ];
  };

  const handler = (key, newValue) => {
    const skill = GECKO_UTILS.setNestedValue(value, key, newValue);
    onChange(skill);
  };

  return (
    <div className="SkillSuggestAnswer">
      <div className="row">
        <GeckoFields values={value} fields={fields()} handler={handler} />
      </div>
    </div>
  );
};
SkillSuggestAnswer.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    internal_skill: 'SUGGEST_ANSWER',
    config: PropTypes.shape({
      messages: PropTypes.arrayOf(PropTypes.string),
      answers: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          url: PropTypes.string,
          answer_id: PropTypes.number,
          skill_id: PropTypes.number,
        })
      ),
    }),
  }),
  onChange: PropTypes.func,
};
export default SkillSuggestAnswer;
